export default __webpack_public_path__ + "static/media/timeshare_dark.d46c0ffb.png";